export default __webpack_public_path__ + "static/media/0x2ab4f9ac80f33071211729e45cfc346c1f8446d5.53c8f2c9.webp";